import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import Button from "../sub-component/Button";
import { useMediaQuery } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { getResource } from "../../redux/thunks/Resource";
import { secondsToDhmsFormat, calculateExpiry } from "../../utils/utilities";

export default function AssessmentTestInfoWrapper(props) {
  const {
    title,
    varrient,
    children,
    primaryBtnTitle,
    secondaryBtnTitle,
    btnWidth,
    secondaryBtnWidth,
    onSecondaryBtnClick,
    onPrimaryBtnClick,
    disablePrimaryBtn,
    loading,
    assessmentData,
  } = props;
  const dispatch = useDispatch();
  const [URL, setURL] = useState();
  const [icon, setIcon] = useState();
  const welcome_video = assessmentData?.welcome_video;
  const isOnWebScreen = useMediaQuery("(min-width:1100px)");
  const resource = useSelector((state) => state.resourceReducer);
  const tenant = useSelector((state) => state.userProfileReducer);

  useEffect(() => {
    (async () => {
      if (assessmentData?.tenant?.image_id) {
        const imageResult = await dispatch(
          getResource({ id: assessmentData?.tenant?.image_id }),
        );
        if (!imageResult.error) {
          setIcon(imageResult.payload.url);
        }
      }
    })();
  }, [assessmentData?.tenant?.image_id]);

  useEffect(() => {
    (async () => {
      if (
        assessmentData?.welcome_video?.video_id &&
        (resource.data === null || !resource?.data?.type.includes("video"))
      ) {
        dispatch(getResource({ id: assessmentData?.welcome_video?.video_id }));
      }
    })();
  }, [assessmentData?.welcome_video?.video_id, resource?.data]);

  return (
    <div
      className={`assessment-info-dialog-box-container ${props.className}`}
      style={{
        maxWidth:
          (varrient === "qq-test" || varrient === "assessmentInstructions") &&
          "100%",
        height:
          varrient === "assessmentInstructions"
            ? "100%"
            : varrient === "qq-test" && "100%",
        ...props.style,
      }}
    >
      {varrient === "assessmentInstructions" ? (
        <div
          className="d-flex flex-column"
          style={{
            width: loading || resource.loading ? "100vw" : "100%",
            height: (loading || resource.loading) && "100vh",
            background: "#FFF",
            borderRadius: "24px",
          }}
        >
          {loading || resource.loading ? (
            <div className="processing-indicator-wrapper medium-indicator">
              <div
                className="processing-indicator primary"
                style={{ width: "100%", height: "100%" }}
              />
            </div>
          ) : (
            <div
              className="w-100 d-flex flex-column align-items-start"
              style={{
                padding: "24px",
                gap: "60px",
              }}
            >
              <div
                className={`w-100 d-flex flex-${
                  isOnWebScreen ? "row" : "column"
                }`}
                style={{ gap: "24px" }}
              >
                <div
                  className={`${
                    isOnWebScreen ? "w-50" : "w-100"
                  } d-flex flex-column`}
                  style={{ gap: "24px" }}
                >
                  <div className="assessment-header">
                    {icon ? (
                      <img
                        className="assessment-header-icon"
                        src={icon}
                        alt=""
                      />
                    ) : (
                      <div className="assessment-header-icon-initial">
                        <span className="body-1 white">
                          {(
                            tenant?.curr_assess_tenant_profile?.company_name?.slice(
                              0,
                              2,
                            ) || ""
                          ).toUpperCase()}
                        </span>
                      </div>
                    )}
                    <span className="headline-1 dark-100">
                      {tenant?.curr_assess_tenant_profile?.company_name}
                    </span>
                  </div>
                  <span className="headline-3 text-start">
                    Welcome to assessment for the{" "}
                    <span>{assessmentData?.title}</span> position.
                  </span>
                  <div
                    className="d-flex flex-column align-items-start"
                    style={{ gap: "12px" }}
                  >
                    <span className="body-2 dark-50 text-start">
                      This online assessment will help us understand your
                      skills, and it is a mandatory step in the evaluation
                      process. Please read the instructions below and start when
                      you are ready.
                    </span>
                    <span className="body-2 dark-50 semibold text-start">
                      Duration:{" "}
                      <span className="normal">
                        {secondsToDhmsFormat(
                          assessmentData?.objective_test_duration ||
                            assessmentData?.duration ||
                            0,
                          false,
                          true,
                        )}
                      </span>
                    </span>
                    <span className="body-2 dark-50 semibold text-start">
                      Deadline:{" "}
                      <>
                        {assessmentData?.deadline ? (
                          <span className="normal">
                            {secondsToDhmsFormat(
                              assessmentData?.objective_test_duration ||
                                assessmentData?.duration ||
                                0,
                              false,
                              true,
                            )}{" "}
                            (submit before timestamp)
                          </span>
                        ) : (
                          <span className="normal">No deadline</span>
                        )}
                      </>
                    </span>
                  </div>
                </div>
                <div
                  className={`${
                    isOnWebScreen ? "w-50" : "w-100"
                  } d-flex flex-row`}
                >
                  {assessmentData?.welcome_video !== null &&
                    !assessmentData?.has_watched_ww && (
                      <div className="welcome-video-container">
                        <div className="video">
                          {welcome_video.type === "url" ? (
                            <ReactPlayer
                              width={"100%"}
                              height={"100%"}
                              controls={true}
                              url={welcome_video?.video_url}
                            />
                          ) : (
                            <video
                              style={{ width: "100%", height: "100%" }}
                              src={resource?.data?.url}
                              controls={true}
                              muted={false}
                              disablePictureInPicture={true}
                              controlsList="nodownload noremoteplayback noplaybackrate"
                            />
                          )}
                        </div>
                      </div>
                    )}
                </div>
              </div>
              <div className="w-100 d-flex flex-column" style={{ gap: "24px" }}>
                <div
                  className={`${
                    isOnWebScreen ? "w-50" : "w-100"
                  } d-flex flex-column`}
                  style={{ gap: "24px" }}
                >
                  <span className="headline-4 dark-100 truncate-title text-start">
                    {title || "Title"}
                  </span>
                  {children}
                </div>
                <div
                  className={`assessment-info-dialog-box-bottom-container`}
                  style={{ borderTop: "none", padding: "0px 0px" }}
                >
                  {!props.disableSecondaryBtn && (
                    <Button
                      btn="ragular-btn"
                      varrient="secondary-btn"
                      style={{ width: "max-content", height: "40px" }}
                      title={secondaryBtnTitle || "Cancel"}
                      onClick={onSecondaryBtnClick}
                    />
                  )}
                  <Button
                    processing={props.processing}
                    disabled={disablePrimaryBtn}
                    btn="ragular-btn"
                    varrient="primary"
                    style={{ width: "max-content", height: "40px" }}
                    title={primaryBtnTitle || "Confirm"}
                    onClick={onPrimaryBtnClick}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div
          className="w-100 d-flex flex-column"
          style={{ background: "#FFF", borderRadius: "24px" }}
        >
          {loading ? (
            <div className="processing-indicator-wrapper medium-indicator">
              <div
                className="processing-indicator primary"
                style={{ width: "100%", height: "100%" }}
              />
            </div>
          ) : (
            <>
              <div className="title d-flex align-items-center justify-content-between">
                <span className="headline-4 dark-100 truncate-title">
                  {title || "Title"}
                </span>
                {props?.test && (
                  <span className="body-2 dark-50">
                    Time:{" "}
                    <span className="dark-100">
                      ~{secondsToDhmsFormat(props?.test?.duration, false, true)}
                    </span>
                  </span>
                )}
              </div>
              <div
                className="w-100"
                style={{ padding: "24px", wordBreak: "break-word" }}
              >
                {children}
              </div>
              <div
                className={`assessment-info-dialog-box-bottom-container ${
                  !props.disableSecondaryBtn && "justify-content-between"
                }`}
                style={{ borderTop: varrient === "qq-test" && "none" }}
              >
                {!props.disableSecondaryBtn && (
                  <Button
                    btn="ragular-btn"
                    varrient="secondary-btn"
                    style={{ width: "max-content", height: "40px" }}
                    title={secondaryBtnTitle || "Cancel"}
                    onClick={onSecondaryBtnClick}
                  />
                )}
                <Button
                  processing={props.processing}
                  disabled={disablePrimaryBtn}
                  btn="ragular-btn"
                  varrient="primary"
                  style={{ width: "max-content", height: "40px" }}
                  title={primaryBtnTitle || "Confirm"}
                  onClick={onPrimaryBtnClick}
                />
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}
